import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { AuthProvider } from './context/AuthContext.js';
import Layout from './generalLayout/index.js';
import AppRoutes from './routes/AppRoutes.js';

export default function App() {
  useEffect(() => {
    const loginSuccess = localStorage.getItem("login_success");
    const logoutSuccess = localStorage.getItem("logout_success");

    if (loginSuccess === "true") {
      localStorage.removeItem("login_success");
      setTimeout(() => toast.success("Login successful!"), 100);
    } else if (logoutSuccess === "true") {
      localStorage.removeItem("logout_success");
      setTimeout(() => toast.success("Logged out successfully!"), 100);
    }
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Layout>
        <ToastContainer />
        <AppRoutes />
        </Layout>
      </Router>
    </AuthProvider>
  );
}
